module.exports = __webpack_public_path__ + "img/Schnitzelparty.e249cf0e.jpg";